(function() { module.exports = this["vendor"]; }());


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 0
// module chunks = 951